export default __webpack_public_path__ + "static/media/package-9.d6acb115.svg";